import { Routes } from '@angular/router';
import { AuthGuard } from '@web/birdz-angular';
import { PageBigqueryUsageComponent } from 'app/components/page-bigquery-usage/page-bigquery-usage.component';
import { PageQueryEditComponent } from 'app/components/page-query-edit/page-query-edit.component';
import { PageQueryExecuteComponent } from 'app/components/page-query-execute/page-query-execute.component';
import { PageQueryListComponent } from 'app/components/page-query-list/page-query-list.component';
import { PageQueryComponent } from 'app/components/page-query/page-query.component';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'favorites', pathMatch: 'full' },
      {
        path: 'favorites',
        component: PageQueryListComponent,
        data: { favoritesOnly: true },
      },
      {
        path: 'queries',
        component: PageQueryListComponent,
      },
      {
        path: 'queries/tags/:tag',
        component: PageQueryListComponent,
      },
      {
        path: 'folder/:folderId',
        component: PageQueryListComponent,
        data: { folderMode: true },
      },
      {
        path: 'bigquery-usage',
        component: PageBigqueryUsageComponent,
      },
      {
        path: 'query',
        component: PageQueryComponent,
        children: [
          { path: '', redirectTo: 'new', pathMatch: 'full' },
          { path: 'new', component: PageQueryEditComponent },
          { path: ':id/edit', component: PageQueryEditComponent },
          { path: ':id', component: PageQueryExecuteComponent },
        ],
      },
      { path: '**', redirectTo: 'queries', pathMatch: 'full' },
    ],
  },
];
